'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'handshake';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f2b5';
var svgPathData = 'M640 400c0 8.844-7.156 16-16 16H576c-20.83 0-38.43-13.42-45.05-32h-31.68c-1.695 4.467-3.529 8.932-6.689 12.84l-9.094 11.25c-14 17.34-38.19 21.88-57.41 11.97l-20.27 24.97c-18.03 21.97-50.47 25.25-72.31 7.406l-6.094-5.281c-11.14 9-25.12 14.88-40.23 16.44C284.5 463.9 281.8 464 279.1 464c-17.58 0-34.48-6-48.33-17.25L149.5 384H109.1C102.4 402.6 84.83 416 64 416H32c-8.844 0-16-7.156-16-16S23.16 384 32 384l32-.0606c8.828 0 16-7.127 16-15.94V160h-64C7.156 160 0 152.8 0 144S7.156 128 16 128h114.9c33.55-33.2 76.95-55.11 122.8-61.77c8.781-1.391 16.86 4.781 18.12 13.53C273.1 88.5 267 96.63 258.3 97.89C217.4 103.8 178.7 124.1 149.3 154.9L144.6 159.8L112 160v192h48.39l90.3 69.69c9.625 7.781 21.22 11.25 33.2 10.06c11.88-1.219 22.56-7 30.09-16.28l10.55-10.53l12.62 8.312L354.1 428c7.844 6.406 20.09 5.094 26.89-3.188l40-49.25l17.56 14.72c5.953 4.719 15.09 3.844 20.03-2.312l9.094-11.25c4.953-6.125 4.016-15.19-2.109-20.19l-108.5-88.11c-6.859-5.578-7.891-15.66-2.328-22.52c5.547-6.844 15.62-7.906 22.52-2.328l108.5 88.14c6.725 5.471 10.75 12.67 13.52 20.28H528V160h-32.31l-4.703-4.797C454.1 117.6 404.7 96 355.6 96h-8.172c-3.562 0-6.953 1.359-9.766 3.922L244.4 187.2C234.3 196.9 235.8 211.1 243.1 219.2C245.6 221.9 251.9 226.1 259.2 226.5c5.125 .0938 10.11-1.609 14.62-5.703l.6406 .7031C282.7 212.4 302.5 194 350.1 149.8c6.469-5.984 16.58-5.656 22.61 .8281c6.016 6.469 5.641 16.59-.8281 22.61L295.4 244.4C285.3 253.6 273.1 258.5 260.2 258.5c-.8594 0-1.719-.0313-2.594-.0625C240.5 257.6 226.6 248.7 219.4 240.6c-19.7-21.69-18.88-54.53 1.734-75.39L221.5 164.8l94.47-88.34C324.8 68.36 335.9 64 347.4 64h8.172c55.52 0 111 23.25 153.4 64H624C632.8 128 640 135.2 640 144S632.8 160 624 160h-64v208c0 8.812 7.17 16.01 15.1 16.01L624 384C632.8 384 640 391.2 640 400z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandshake = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;